import type { VueConstructor } from 'vue';
import autofocus from './autofocus';

export default {
  install(Vue: VueConstructor): void {
    Vue.directive('autofocus', autofocus);
  },
};
